/* global axios */
import ApiClient from './ApiClient';

class IntegrationEvents extends ApiClient {
  constructor() {
    super('integration_events', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }
}

export default new IntegrationEvents();
